import { FETCH_DASHBOARD_DATA, DASHBOARD_DATA_FETCH_FAILED } from 'bundles/project/actions/index';

export default function (state = { data: {}, didFetch: false, error: false }, action) {
  switch (action.type) {
  case FETCH_DASHBOARD_DATA: {
    return { ...state, data: action.payload, didFetch: true };
  }
  case DASHBOARD_DATA_FETCH_FAILED:
    return { ...state, didFetch: true, error: true };
  default: {
    return state;
  }
  }
}
